import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {Box, Tooltip, Typography} from '@mui/material'
import CustomCard from "../CustomCardComponent/CustomCard";
import GroupAffiliationSelectionModal from "../Reservation/GroupAffiliationSelectionModal";
import { fetchReservationContractsApi} from "@/utils/PricingService/PricingApi";
import { AlertMessage } from "../AlertMessage";
import { Button } from "@/components";
import NoContractAffiliationCard from "@/components/Reservation/NoContractAffiliationCard";

const ReservationGPOComponent = ({ productsForPricing, onContractChange, setSelectedContract, selectedContract, isEditing }) => {
    const { reservation } = useSelector((store) => store?.commerce);
    const reservationData = reservation?.reservation;
    const { reservationPriceContracts = []} = useSelector((state) => state?.commerce);
    const selectedGpoAffiliatedId = selectedContract?.id || selectedContract?.contractId;
    const [openSelectionModal, setOpenSelectionModal] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const userId = useSelector((store) => store?.commerce?.userData?.userId) || '';
    const dispatch = useDispatch();
    const alertRef = useRef(null);
    const [contractTooltipDismissed, setContractTooltipDismissed] = useState(false);
    const isNewReservation = reservationData?.reservationStatus === "CREATED" && 
        !reservation?.reservationEntries?.length && !isEditing &&
        reservationPriceContracts?.length > 0

    const alert = (message, type) => {
        setAlertMessage(message);
        setAlertType(type);
    }

    const contractTooltip = (
        <Box p='16px 12px'>
            <Box pb='20px'>
                <Typography variant='p1'>You can change your contract affiliation at any time by clicking here.</Typography>
            </Box>
            <Button
                buttonType='mds-tertiary'
                sx={{ textTransform: 'none' }}
                onClick={() => setContractTooltipDismissed(true)}
            >
                Got it
            </Button>
        </Box>
    )
    
    const fetchEligibleContracts = async () => {
        try {
            await dispatch(fetchReservationContractsApi({ payload: { productNumbers: productsForPricing, userId: userId }})).unwrap();
        } catch (error) {
            let errorMsg = 'We are unable to fetch your contracts at the moment. Please refresh and try again or contact us at 1-866-MODERNA.';
            alert(errorMsg, 'error');
            alertRef.current?.openAlert(error);
        }
    };
    
    useEffect(() => {
        fetchEligibleContracts();
    }, [dispatch]);
    
    const handleConfirm = (selectedPriceContract) => {
        onContractChange(selectedPriceContract);
    };

    const getSelectedContractDetails = (cartContractId) => {
        return reservationPriceContracts?.find(contract => contract?.id === cartContractId);
    }

    useEffect(() => {
        if (
            reservationData?.contractInfo &&
            reservationPriceContracts.length > 0
        ) {
            const matchedContract = getSelectedContractDetails(reservationData.contractInfo.contractId);

            if (matchedContract) {
                setSelectedContract && setSelectedContract(matchedContract);
            }
        }
    }, [reservationData?.contractInfo, reservationPriceContracts]);

    useEffect(() => {
        if (isNewReservation) {
            setContractTooltipDismissed(true)
            setOpenSelectionModal(true);
        }
    }, [reservationPriceContracts]);
    
    const renderContractAffiliationCard = () => {
            return (
                <>
                    <AlertMessage variant={"filled"} type={alertType} message={alertMessage} sx={{ top: 120 }} ref={alertRef} />
                    {!reservationPriceContracts.length ? (
                        <NoContractAffiliationCard />
                    ) : (
                        <CustomCard sx={{padding: "16px 32px"}}>
                            <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                                <Box display="flex" alignItems="center">
                                    <Typography variant='h5' style={{ fontSize: '18px', marginRight: '8px' }}>
                                        {selectedContract?.displayName ? 'Contract affiliation:' + '\u00A0' + selectedContract?.displayName : 'No contract affiliation selected.'}
                                    </Typography>
                                        <Tooltip title={contractTooltip} placement='bottom-start' arrow open={!contractTooltipDismissed} componentsProps={{
                                        tooltip: {
                                            sx: {
                                                backgroundColor: '#F1F9FE',
                                                color: '#252627',
                                                boxShadow: 1,
                                                fontSize: '16px'
                                            }
                                        },
                                        arrow: {
                                            sx: {
                                                color: '#F1F9FE'
                                            }
                                        }
                                    }}>
                                        <Typography
                                            variant='body1'
                                            color='secondary.textLinks'
                                            data-testid='selectAffiliationBtn'
                                            onClick={() => setOpenSelectionModal(true)}
                                            style={{
                                                cursor: 'pointer',
                                                fontSize: '18px'
                                            }}
                                        >
                                            Change
                                        </Typography>
                                    </Tooltip>
                                </Box>
                                <Box>
                                    <Typography>
                                        Incorrect pricing?
                                        <Link to={"/contact-us"} style={{ color: "#0379B2" }}> Contact us</Link>
                                    </Typography>
                                </Box>
                            </Box>
                        </CustomCard>
                    )}
                </>
            )
    }
    return (
        <Box display="flex" flexDirection="column" mt={2} minHeight={'50px'} data-testid="gpoComponent">
            {renderContractAffiliationCard()}
            { openSelectionModal &&
                <GroupAffiliationSelectionModal
                    openModal={openSelectionModal}
                    closeModal={()=> setOpenSelectionModal(false)}
                    handleConfirm={ handleConfirm }
                    defaultGpoAffiliatedId={selectedGpoAffiliatedId}
                    productsForPricing={productsForPricing}
                    setSelectedContract={setSelectedContract}
                    isReservation={true}
                />
            }
        </Box>
    )
}

export default ReservationGPOComponent
